import {
  background,
  radius,
  padding,
  spacing,
  border,
  flex,
  margin,
  gap,
  screen,
} from '@ebh/capsule/theme';

export default {
  container: [
    screen(
      'md',
      background('white'),
      radius(4),
      padding(4),
      border(1, 'gray-100'),
      {
        position: 'absolute' as const,
        top: '4vh',
        right: 0,
        width: spacing(60),
        zIndex: 1000,
      },
    ),
  ],
  userProfile: [
    flex('row'),
    radius(3),
    padding(3),
    margin(2, 'top'),
    margin(2, 'left'),
    gap(1),
    {
      alignItems: 'center',
    },
    screen('md', background('gray-100'), gap(0), margin(0)),
  ],
  userProfileIcon: [
    margin(2, 'right'),
    background('gray-200'),
    radius('50%'),
    padding(1),
  ],
  menuIcon: [
    flex('center'),
    {
      width: 20,
      height: 20,
      alignItems: 'center',
    },
  ],
  menuItem: [
    radius(2),
    padding(3),
    margin(5, 'left'),
    flex('row'),
    margin(2, 'top'),
    gap(3),
    { cursor: 'pointer', alignItems: 'center' },
    screen('md', margin(0, 'left'), gap(2), margin(0, 'y')),
  ],
  menu: [flex('column', 'items-start')],
};
